export default () => ({
  index: null,

  init() {
    this.index = parseInt(this.$el.dataset.index);
  },
});
